// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.60-TSS-3055-mcastro-IMPROVEMENT-Clear-All-Content-button-for-Duplicate-To-Feature.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
